<ion-menu content-id="main-content" menu-id="menuId">
    <ion-content color="primary">
        <ion-list mode="ios" lines="none">
            <ion-menu-toggle menu="start">
                <ion-item class="avatar">
                    <ion-avatar slot="start" (click)="takePic()">
                        <img [src]="auth.usuario?.imagem || 'assets/no-image.png'" appImgOffline />
                    </ion-avatar>
                    <ion-label routerLink="/user">
                        <h2>{{ auth.usuario?.pessoa?.nome }}</h2>
                        <p>{{ auth.usuario?.email }}</p>
                    </ion-label>
                </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle menu="start" *ngIf="session">
                <ion-item (click)="resetSession()">
                    <ion-icon slot="start" name="key-outline"></ion-icon>
                    <ion-label>Acessar Como {{ session.usuario?.pessoa.nome }}</ion-label>
                </ion-item>

                <ion-item (click)="simularSincronizacao()" *ngIf="session.usuario?.admin">
                    <ion-icon slot="start" name="reload-circle-outline"></ion-icon>
                    <ion-label>Simular Sincronização</ion-label>
                </ion-item>
            </ion-menu-toggle>
        </ion-list>

        <ion-list mode="ios" lines="none">
            <ion-menu-toggle menu="start">
                <ion-item routerLink="/" [ngClass]="(router.url === '/' ? 'selected' : '')">
                    <ion-icon slot="start" name="flame-outline"></ion-icon>
                    <!-- <ion-icon slot="start" name="home-outline"></ion-icon> -->
                    <ion-label>Início</ion-label>
                  </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle menu="start" *ngIf="(auth.usuario?.master || auth.usuario?.permissoes.calculadora) && !auth.usuario?.cliente?.modular && !auth.usuario?.estabelecimento && auth.online()">
                <ion-item routerLink="/calculadora" [ngClass]="(router.url === '/calculadora' ? 'selected' : '')">
                    <ion-icon slot="start" name="calculator-outline"></ion-icon>
                    <ion-label>Dimensionamento</ion-label>
                  </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle menu="start" *ngIf="auth.online()">
                <ion-item routerLink="/ajuda" [ngClass]="(router.url.indexOf('ajuda') !== -1 ? 'selected' : '')">
                    <ion-icon slot="start" name="help-circle-outline"></ion-icon>
                    <ion-label>Tutoriais</ion-label>
                  </ion-item>
            </ion-menu-toggle>

            <ng-container *ngIf="auth.usuario?.estabelecimento && auth.usuario?.edificacao && !auth.usuario?.cliente?.modular">
                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.master || auth.usuario?.permissoes.relatorio || auth.usuario?.permissao('relatorio', 'view') || auth.usuario?.permissao('relatorio', 'viewAny')">
                    <ion-item *ngIf="auth.online()" routerLink="/dashboard" [ngClass]="(router.url.indexOf('dashboard') !== -1 ? 'selected' : '')">
                        <ion-icon name="pie-chart-outline" slot="start"></ion-icon>
                        <ion-label>Dashboard</ion-label>
                    </ion-item>
                </ion-menu-toggle>

				<ng-container *ngIf="auth.usuario?.cliente?.conf.inspecao">
					<ion-menu-toggle menu="start" *ngIf="auth.usuario?.master || auth.usuario?.permissoes.atividade || (!auth.usuario?.perfil && auth.usuario?.isBrigadista) || auth.usuario?.permissao('atividade')">
						<ion-item routerLink="/atividade" [ngClass]="(router.url === '/atividade' ? 'selected' : '')">
							<ion-icon name="clipboard-outline" slot="start"></ion-icon>
							<ion-label>{{ 'inspections.title' | translate }}</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle menu="start" *ngIf="auth.usuario?.master || auth.usuario?.permissoes.pendencia || (!auth.usuario?.perfil && auth.usuario?.isBrigadista) || (!auth.usuario?.perfil && auth.usuario?.isResidente) || auth.usuario?.permissao('pendencia')">
						<ion-item routerLink="/pendencia" [ngClass]="(router.url === '/pendencia' ? 'selected' : '')">
							<ion-icon name="list-outline" slot="start"></ion-icon>
							<ion-label>{{ 'deviations.title' | translate }}</ion-label>
						</ion-item>
					</ion-menu-toggle>
					<ion-menu-toggle menu="start" *ngIf="auth.usuario?.master || auth.usuario?.permissoes.equipamento || (!auth.usuario?.perfil && auth.usuario?.isBrigadista) || auth.usuario?.permissao('equipamento')">
						<ion-item routerLink="/equipamento" [ngClass]="(router.url === '/equipamento' ? 'selected' : '')">
							<ion-icon slot="start" name="hardware-chip-outline"></ion-icon>
							<ion-label>{{ 'equipment.title' | translate }}</ion-label>
						</ion-item>
					</ion-menu-toggle>
				</ng-container>
                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.moduloHabilitado('bloco_nota') && (auth.usuario?.master || auth.usuario?.permissoes.bloco_nota || (!auth.usuario?.perfil && auth.usuario?.isBrigadista) || (!auth.usuario?.perfil && auth.usuario?.isResidente) || auth.usuario?.permissao('bloco_nota'))">
                    <ion-item routerLink="/bloco-nota" [ngClass]="(router.url.indexOf('bloco-nota') !== -1 ? 'selected' : '')">
                        <ion-icon slot="start" name="document-text-outline"></ion-icon>
                        <ion-label>Bloco de Notas</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.cliente?.conf.certificado && (auth.usuario?.master || auth.usuario?.permissoes.certificado || auth.usuario?.permissao('certificado')) && auth.online()">
                    <ion-item routerLink="/certificado" [ngClass]="(router.url === '/certificado' ? 'selected' : '')">
                        <ion-icon slot="start" name="school-outline"></ion-icon>
                        <ion-label>Certificados</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.cliente?.conf.documento && (auth.usuario?.master || auth.usuario?.permissoes.documento || auth.usuario?.permissao('documento')) && auth.online()">
                    <ion-item routerLink="/documento" [ngClass]="(router.url === '/documento' ? 'selected' : '')">
                        <ion-icon slot="start" name="documents-outline"></ion-icon>
                        <ion-label>Documentos</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.cliente?.conf.edificacao && auth.usuario?.isBrigadista && (!auth.usuario?.perfil || auth.usuario?.permissao('edificacao', 'view'))">
                    <ion-item routerLink="/edificacao/documentos" [ngClass]="(router.url === '/edificacao/documentos' ? 'selected' : '')">
                        <ion-icon slot="start" name="document-attach-outline"></ion-icon>
                        <ion-label>Doc. Edificação e PAE</ion-label>
                    </ion-item>
                </ion-menu-toggle>

                <ng-container *ngIf="auth.usuario">
                    <ion-menu-toggle menu="start" *ngIf="auth.online() && auth.usuario.cliente?.conf.treinamento && (auth.usuario.master || auth.usuario.permissoes.treinamento || (!auth.usuario.perfil && auth.usuario.isBrigadista) || auth.usuario.permissao('treinamento') || (auth.usuario.bombeiro && !auth.usuario.brigadista && !auth.usuario.residente && auth.usuario.cliente?.conf.avaliacao_gestor_brigada))">
                        <ion-item routerLink="/treinamento" [ngClass]="(router.url === '/treinamento' ? 'selected' : '')">
                            <ion-icon slot="start" name="checkmark-done-circle-outline"></ion-icon>
                            <ion-label>Avaliação do Brigadista</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                    <ion-menu-toggle menu="start" *ngIf="auth.online() && auth.usuario.cliente?.conf.tutorial">
                        <ion-item routerLink="/tutorial" [ngClass]="(router.url === '/tutorial' ? 'selected' : '')">
                            <ion-icon slot="start" name="play-circle-outline"></ion-icon>
                            <ion-label>Primeiros Socorros</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                    <ion-menu-toggle menu="start" *ngIf="auth.usuario.cliente?.conf.brigadista && (auth.usuario.master || auth.usuario.permissoes.brigadista || (!auth.usuario.perfil && auth.usuario.isBrigadista) || (!auth.usuario.perfil && auth.usuario.isResidente) || auth.usuario.permissao('brigadista'))">
                        <ion-item routerLink="/brigadista" [ngClass]="(router.url === '/brigadista' ? 'selected' : '')">
                            <ion-icon slot="start" name="bonfire-outline"></ion-icon>
                            <!-- <fa-icon slot="start" icon="fire-extinguisher"></fa-icon> -->
                            <ion-label>Brigada de Incêndio</ion-label>
                        </ion-item>
                    </ion-menu-toggle>
                </ng-container>

                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.cliente?.conf.brigada && (auth.usuario?.master || auth.usuario?.permissoes.brigada || auth.usuario?.permissao('brigada')) && auth.online()">
                    <ion-item routerLink="/brigada" [ngClass]="(router.url === '/brigada' ? 'selected' : '')">
                        <ion-icon slot="start" name="help-buoy-outline"></ion-icon>
                        <ion-label>Grupos de Brigada</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.cliente?.conf.plantao && (auth.usuario?.master || (!auth.usuario?.perfil && auth.usuario?.isBrigadista) || auth.usuario?.permissoes.plantao || auth.usuario?.permissao('plantao'))">
                    <ion-item routerLink="/plantao" [ngClass]="(router.url === '/plantao' ? 'selected' : '')">
                        <ion-icon slot="start" name="calendar-outline"></ion-icon>
                        <ion-label>Relatório de Turno</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.cliente?.conf.ata && (auth.usuario?.master || (!auth.usuario?.perfil && auth.usuario?.isBrigadista) || auth.usuario?.permissoes.ata || auth.usuario?.permissao('ata'))">
                    <ion-item routerLink="/ata" [ngClass]="(router.url === '/ata' ? 'selected' : '')">
                        <!-- <fa-icon slot="start" icon="file-signature"></fa-icon> -->
                        <ion-icon slot="start" name="create-outline"></ion-icon>
                        <ion-label>Atas</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.online() && auth.usuario?.cliente?.conf.agenda && (auth.usuario?.master || (!auth.usuario?.perfil && auth.usuario?.isBrigadista) || auth.usuario?.permissoes.agenda || auth.usuario?.permissao('agenda'))">
                    <ion-item routerLink="/agenda" [ngClass]="(router.url === '/agenda' ? 'selected' : '')">
                        <ion-icon slot="start" name="calendar-number-outline"></ion-icon>
                        <ion-label>Agenda</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.cliente?.conf.estoque && (auth.usuario?.master || (!auth.usuario?.perfil && auth.usuario?.isBrigadista) || auth.usuario?.permissoes.estoque || auth.usuario?.permissoes.almoxarifado || auth.usuario?.permissao('estoque') || auth.usuario?.permissao('almoxarifado'))">
                    <ion-item routerLink="/estoque" [ngClass]="(router.url === '/estoque' ? 'selected' : '')">
                        <!-- <fa-icon slot="start" icon="tags"></fa-icon> -->
                        <ion-icon slot="start" name="pricetags-outline"></ion-icon>
                        <ion-label>Controle de Estoque</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.online()">
                    <ion-item routerLink="/epi-entrega" [ngClass]="(router.url.startsWith('/epi-entrega') ? 'selected' : '')">
                        <ion-icon slot="start" name="shield-checkmark-outline"></ion-icon>
                        <ion-label>Meus EPIs</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.online() && auth.usuario?.cliente?.conf.exercicio && (auth.usuario?.master || (!auth.usuario?.perfil && auth.usuario?.isBrigadista) || auth.usuario?.permissoes.exercicio || auth.usuario?.permissao('exercicio'))">
                    <ion-item routerLink="/simulacao" [ngClass]="(router.url === '/simulacao' ? 'selected' : '')">
                        <ion-icon slot="start" name="stopwatch-outline"></ion-icon>
                        <ion-label>Simulações</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.online() && auth.usuario?.cliente?.conf.ponto_encontro && (auth.usuario?.master || (!auth.usuario?.perfil && auth.usuario?.isBrigadista) || auth.usuario?.permissoes.ponto_encontro || auth.usuario?.permissao('ponto_encontro'))">
                    <ion-item routerLink="/ponto-encontro" [ngClass]="(router.url === '/ponto-encontro' ? 'selected' : '')">
                        <fa-icon slot="start" icon="street-view"></fa-icon>
                        <ion-label>Pontos de Encontro</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.online() && auth.usuario?.cliente?.conf.help">
                    <ion-item routerLink="/sinistro" [ngClass]="(router.url === '/sinistro' ? 'selected' : '')">
                        <fa-icon slot="start" icon="dumpster-fire"></fa-icon>
                        <ion-label>Emergências</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.master || auth.usuario?.permissoes.edificacao || auth.usuario?.permissao('edificacao')">
                    <ion-item routerLink="/edificacao" [ngClass]="(router.url === '/edificacao' ? 'selected' : '')">
                        <ion-icon slot="start" name="business-outline"></ion-icon>
                        <ion-label>Edificações</ion-label>
                    </ion-item>
                </ion-menu-toggle>
                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.master || auth.usuario?.admin || auth.usuario?.permissao('usuario')">
                    <ion-item routerLink="/usuario" [ngClass]="(router.url === '/usuario' ? 'selected' : '')">
                        <ion-icon slot="start" name="people-outline"></ion-icon>
                        <ion-label>Usuários</ion-label>
                    </ion-item>
                </ion-menu-toggle>
            </ng-container>

            <app-menu-modular *ngIf="auth.usuario?.estabelecimento && auth.usuario?.edificacao && auth.usuario?.cliente?.modular"></app-menu-modular>

            <ng-container *ngIf="auth.usuario?.admin || !auth.usuario?.cliente">
                <!-- <ion-menu-toggle menu="start" *ngIf="auth.usuario?.admin || auth.usuario?.permissoes.cliente || auth.usuario?.permissao('cliente')">
                    <ion-item routerLink="/cliente" [ngClass]="(router.url === '/cliente' ? 'selected' : '')">
                        <ion-icon slot="start" name="business-outline"></ion-icon>
                        <ion-label>Clientes</ion-label>
                    </ion-item>
                </ion-menu-toggle> -->

                <ion-menu-toggle menu="start" *ngIf="auth.usuario?.admin || auth.usuario?.permissao('usuario')">
                    <ion-item routerLink="/usuario" [ngClass]="(router.url === '/usuario' ? 'selected' : '')">
                        <ion-icon slot="start" name="people-outline"></ion-icon>
                        <ion-label>Usuários</ion-label>
                    </ion-item>
                </ion-menu-toggle>
            </ng-container>

            <ion-menu-toggle menu="start" *ngIf="auth.online()">
                <ion-item routerLink="/notificacao" [ngClass]="(router.url === '/notificacao' ? 'selected' : '')">
                    <ion-icon slot="start" name="notifications-outline"></ion-icon>
                    <ion-label>Notificações</ion-label>
                    <ion-badge color="tertiary" mode="ios" slot="end">{{ auth.usuario?.qtd_notificacoes ? auth.usuario?.qtd_notificacoes : '' }}</ion-badge>
                  </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle menu="start">
                <ion-item routerLink="/configuracao" [ngClass]="(router.url.indexOf('configuracao') !== -1 ? 'selected' : '')">
                    <ion-icon slot="start" name="settings-outline"></ion-icon>
                    <ion-label>Configurações</ion-label>
                  </ion-item>
            </ion-menu-toggle>
            <ion-menu-toggle menu="start">
                <ion-item routerLink="/sobre" [ngClass]="(router.url.indexOf('sobre') !== -1 ? 'selected' : '')">
                    <ion-icon slot="start" name="information-circle-outline"></ion-icon>
                    <ion-label>Sobre</ion-label>
                  </ion-item>
            </ion-menu-toggle>

            <ion-menu-toggle menu="start">
                <ion-item [href]="linkWeb" target="_blank">
                    <ion-icon slot="start" name="desktop-outline"></ion-icon>
                    <ion-label>Sistema Web</ion-label>
                  </ion-item>
            </ion-menu-toggle>
        </ion-list>

        <ion-grid fixed>
            <ion-row class="ion-align-items-center">
                <ion-col size="6">
                    <div class="ion-padding" *ngIf="auth.usuario?.edificacao?.imagem">
                        <img [src]="auth.usuario?.edificacao?.imagem" alt="" appImgOffline>
                    </div>

                    <div class="ion-padding" *ngIf="!auth.usuario?.edificacao?.imagem && auth.usuario?.estabelecimento?.imagem">
                        <img [src]="auth.usuario?.estabelecimento?.imagem" alt="" appImgOffline>
                    </div>
                </ion-col>
                <ion-col size="6">
                    <img src="assets/logos/logo-branco-2.png" alt="">
                </ion-col>
            </ion-row>
        </ion-grid>

        <div class="ion-padding-horizontal mgt-5">
            <ion-text color="warning" class="fs-12">
                Versão: {{ appInfo?.version || '0.10.3' }}
            </ion-text>
        </div>
    </ion-content>
</ion-menu>
<div class="ion-page" id="main-content">
    <ion-fab vertical="bottom" horizontal="center" slot="fixed" *ngIf="isSinc()">
        <ion-fab-button color="light" (click)="shwSincMessage()">
            <ion-spinner name="circles" color="primary"></ion-spinner>
        </ion-fab-button>
    </ion-fab>
    <ion-router-outlet></ion-router-outlet>
</div>
<ion-menu contentId="main-content" menuId="menuEd" side="end" type="push" swipe-gesture="false" *ngIf="eds">
    <ion-header mode="ios">
        <ion-toolbar color="primary">
            <ion-title>Fixar Edificação</ion-title>
        </ion-toolbar>
    </ion-header>
    <ion-content color="primary">
        <ion-list mode="ios" lines="none">
            <ng-container *ngFor="let e of auth.usuario?.cliente?.estabelecimentos">
                <ion-list-header color="secondary">
                    <ion-label class="ion-text-wrap">
                        <h2>{{ e.pessoa.nome }}</h2>
                    </ion-label>
                </ion-list-header>
                <ion-item *ngFor="let item of e.edificacoes" class="mg-0" [class.setted]="auth.usuario?.edificacao?.id === item.id" (click)="setEdificacao(item, e)">
                    <ion-label class="ion-text-wrap">
                        <h2>{{ item.sequencia }} - {{ item.descricao }}</h2>
                        <ion-text color="light" *ngIf="item.qtd_mensagens > 0">
                            <p>{{item.qtd_mensagens}} {{item.qtd_mensagens > 1 ? 'mensagens não lidas' : 'mensagem não lida'}}</p>
                        </ion-text>
                    </ion-label>
                    <ion-icon *ngIf="auth.usuario?.edificacao?.id === item.id" slot="end" name="checkmark-circle"></ion-icon>
                    <ion-icon *ngIf="auth.usuario?.edificacao?.id !== item.id" slot="end" name="chevron-forward"></ion-icon>
                </ion-item>
            </ng-container>
        </ion-list>

        <ion-menu-toggle menu="menuEd">
            <ion-button class="mg-0" mode="ios" routerLink="/edificacao" expand="full" color="tertiary" *ngIf="auth.usuario?.master">
                Gerenciar Edificações
            </ion-button>
        </ion-menu-toggle>

    </ion-content>
</ion-menu>
